import React from "react"
import { Center, Flex, Heading, Link as ChakraLink, Stack, Text } from '@chakra-ui/react';
import { ConfigMenuItem } from './components/ConfigMenuItem';
import { FiEdit, FiShieldOff, FiUnlock, FiUserX } from 'react-icons/fi';
import { MdKeyboardArrowLeft } from 'react-icons/md';
import { Link as RouterLink } from 'react-router-dom';


export const Settings = () => {
  return (
    <>
      <Heading as='h2' fontSize="xl">Configuraciones</Heading>

      <Center marginTop="xxxl">
        <Stack spacing="xl" borderWidth="1px" borderColor="neutral.300" borderRadius="xl" padding="xxxl">
          <ConfigMenuItem link="security" icon={<FiUnlock />} label="Seguridad" description="Tiene configurada la seguridad de su cuenta" />
          {/* <ConfigMenuItem icon={<FiEdit />} label="Dashboard" description="Puede configurar las preferencias del Dashboard inicial" />
          <ConfigMenuItem icon={<FiShieldOff />} label="Privacidad" description="Preferencias y control sobre el uso de sus datos" />
          <ConfigMenuItem icon={<FiUserX />} label="Cerrar cuenta" description="Rellena la solicitud para dar de baja a la cuenta" /> */}
        </Stack>
      </Center>
    </>
  )
}
